<template>
<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M3 4H23L3 11.7037H22.3939L3 17.037H19.9697L5.42424 20H13.9091L3 4Z" stroke="#458EAF"/>
</svg>
</template>
